const AOS = require('aos');
const { data } = require('jquery');
const $ = require('jquery');
// const _ = require('lodash');

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');

window.jQuery = $;

$(function () {
  loadAOS();
  initSliders();
  initGoogleMapping();
  containerFix();
  submenuOffset();
  heroOffset();
  resizeLogic();
  overlayColour();
  overlapColour();
  slickWindow();
  checkWindowScroll();
  hoverLinks();

  // Runs server image replace function based on domain
  if (window.location.hostname === 'sano-physiotherapy.test' || window.location.hostname === 'localhost') {
    imageReplace();
  }

  $('body section').each(function () {
    var $currentSection = $(this);

    if ($($currentSection).hasClass('knowledge-block')) {
      knowledgeSelect();
    };
  });
  
  $(window).on('load', function() {
    $('video').each(function() {
      // Set the 'data-src' attribute as the source for each video
      $(this).attr('src', $(this).data('src'));
      this.load(); // Optional: Forces the browser to load the video
    });
  });

  // handler for the resize window event
  $(window).on("resize", function () {
    containerFix();
    resizeLogic();
    submenuOffset();
    slickWindow();
  });
  // handler for the scroll window event
  $(window).on("scroll", function () {
    checkWindowScroll();
    uncoverElements();
  });

  if ($('#hero').hasClass('bg-nonary')) {
    $('#header').addClass('dark-header');
  };

  // Header Fix (If the header has a border inside keep the + 1 else remove it)
  function resizeLogic() {
    let heightFix;
    heightFix = $("header").outerHeight();

    $('.header-fix').height(heightFix);
    $('#anchorNav').css('top', heightFix + 'px');
  }

  if ($('body').hasClass('page-template-page-team')) {
    var initialOffset = 568;
    $(window).scroll(function() {
      // Get the current scroll position
      var scrollPosition = $(window).scrollTop();
  
      // Check if the element has reached its sticky position
      if (scrollPosition >= initialOffset) {
        $('#anchorNav').addClass('scroll');
      } else {
        $('#anchorNav').removeClass('scroll');
      }
    });
  }

  // Location Form Submission
  function redirectToPostcode(postcode) {
    urlVal = $('.postcode-form').attr('data-location');

    window.location.href = urlVal + '?postcode-filter=' + postcode;
  }
  
  $('.postcode-form input').keypress(function(e) {
    if (e.which === 13) {
      e.preventDefault();
      redirectToPostcode($(this).val());
    }
  });
  
  $('.postcode-form .submit-btn').on('click', function(e) {
    e.preventDefault();
    redirectToPostcode($('.postcode-form input').val());
  });

  // Colour Overlay

  function overlapColour() {
    var bgClass = 'overlap-section';

    // Iterate through all section tags
    $('body section').each(function () {
      var $currentSection = $(this);

      // Check if the current section has the specified background class
      if ($currentSection.hasClass(bgClass)) {
        // Check if the previous section also has the same background class
        var $prevSection = $currentSection.prev('section');
        if ($prevSection.hasClass('bg-grey-gradient')) {
          $currentSection.addClass('grey-overlay');
        } else if ($prevSection.hasClass('bg-grey-blue')) {
          $currentSection.addClass('blue-overlay');
        } else {
          $currentSection.addClass('white-overlay');
        }
      }
    });
  }

  // The Knowledge Select
  function knowledgeSelect() {
    // Get the select element
    var selectElement = document.getElementById('selectOptions');

    // Add a change event listener to the select element
    selectElement.addEventListener('change', function() {
      // Get the selected option's value
      var selectedValue = selectElement.value;

      // Check if a valid option is selected
      if (selectedValue) {
        // Redirect to the selected option's URL
        window.location.href = selectedValue;
      }
    });

    // Iterate through all section tags
    $('.knowledge-section').each(function () {
      var $currentSection = $(this);
      var $nextSection = $currentSection.next('section');

      if ($nextSection.hasClass('bg-nonary') || $nextSection.hasClass('bg-grey-gradient')) {
        $currentSection.addClass('grey-overlay');
      } else if ($nextSection.hasClass('bg-quaternary') || $nextSection.hasClass('bg-blue-gradient')) {
        $currentSection.addClass('blue-overlay');
      } else {
        $currentSection.addClass('white-overlay');
      }
    });
  }

  // Our Location Overlay
  function overlayColour() {
    var bgClass = 'overlay-section';

    // Iterate through all section tags
    $('body section').each(function () {
      var $currentSection = $(this);

      // Check if the current section has the specified background class
      if ($currentSection.hasClass(bgClass)) {
        // Check if the previous section also has the same background class
        var $prevSection = $currentSection.prev('section');
        if ($prevSection.hasClass('bg-nonary') || $prevSection.hasClass('bg-grey-gradient')) {
          $currentSection.addClass('grey-overlay');
        } else if ($prevSection.hasClass('bg-quaternary') || $prevSection.hasClass('bg-blue-gradient')) {
          $currentSection.addClass('blue-overlay');
        } else {
          $currentSection.addClass('white-overlay');
        }
      }
    });
  }

  // Post Navigation Mobile
  $('#navigationButton').on('click', function(){
    $('#navigationLinks').toggleClass('active');
    $(this).toggleClass('active');
  });

  // Menu Hover
    // Add click event handler to the "Close Menu" button
    $(".close-mega").on("click", function() {
      // Remove the hover state by removing the 'hover' class from the parent li
      $("#navigation > ul li.nav-item").removeClass("hover-active");
    });

  // Stop Popup video playing
  $(".btn-close").on("click", function() {
    $('iframe').attr('src', $('iframe').attr('src'));
    $('video').get(0).pause();
  });

  // Smooth scroll.
  $('a[href*="#"]')
  .not('[href="#"]')
  .not('[href="#0"]')
  .on("click", function(event) {
    // Get the target element
    var target = $(this.hash);
    var offset = $("header").outerHeight();
    var altoffset = $("#topBanner").outerHeight();
    offset = offset + altoffset;

    // Check if the target element exists
    if (target.length) {
      // Prevent the default anchor behavior
      event.preventDefault();

      // Scroll to the target using animate with "easeOutExpo" easing
      $('html, body').animate(
        {
          scrollTop: target.offset().top - offset
        },
        {
          easing: "easeOutExpo",
          duration: 250,
        }
      );
    }
  });

  // Burger click
  $("#burger").click(function () {
    open = !open;
    toggleMenu(open);
  });

  // Active class.
  $("header .nav [href]").each(function () {
    if (this.href == window.location.href) {
      $(this).addClass("active");
    }
  });

  function slickArrows(sliderClass, leftValue, rightValue) {
    // Slick Arrow Fix
    const halfDotWidth = $(sliderClass + " .slick-dots").innerWidth() / 2;
    const leftPosition = halfDotWidth + leftValue;
    const rightPosition = halfDotWidth + rightValue;
  
    $(sliderClass + " .slick-next").css('right', 'calc(50% - ' + rightPosition + 'px)');
    $(sliderClass + " .slick-prev").css('left', 'calc(50% - ' + leftPosition + 'px)');
  }

  function slickWindow() {
    slickArrows(".case-study-nav-slider", 50, 50);
    slickArrows(".timeline-nav-slider", 50, 50);
    slickArrows(".stat-slider", 50, 50);
    slickArrows(".stat-mobile-slider", 50, 50);  
    slickArrows(".review-nav-slider", 50, 50);  
  };

  // Submenu.
  $(".submenu-toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).prev(".parent-item").toggleClass("open");
    var submenu = $(this).next(".submenu");
    submenu.addClass("open");
  });

  $(".back-btn").on("click", function() {
    var currentItem = $(this);
    var submenu = currentItem.closest(".submenu");
    submenu.removeClass("open");
  });

  // Redirect URL on Select change
  function redirectToSelectedUrl() {
    // Get the selected option's value
    var selectedUrl = $('#selectOptions').val();

    // Redirect to the selected URL
    window.location.href = selectedUrl;
  }

  $('#selectOptions').change(function() {
    redirectToSelectedUrl();
  });

  // Show more Cities JS
    // Initially hide the last three cards
    $('.city-cards .city-card:gt(5)').hide();

    // Show/Hide button click
    $('#showHide').on('click', function() {
      // Toggle the visibility of the last three cards
      $('.city-cards .city-card:gt(5)').toggle();
      $('#showHideText').toggle();

      // Change button text based on the current state
      var buttonText = $(this).text() === 'Show More' ? 'Show Less' : 'Show More';
      $(this).text(buttonText);
    });

  // Calculator jQuery
    // Initialize the current step
    var currentStep = 1;
    $('#multistep-form .step-position').addClass('active');

    // Function to show the current step and hide others
    function showStep(step) {
      $('.form-step').removeClass('active');
      $('.step-' + step).addClass('active');
      $('.number-step').removeClass('active');
      $('.number-step-' + step).addClass('active');
      $('.title-step').removeClass('active');
      $('.title-step-' + step).addClass('active');
    }

    // Event handler for "Next" button
    $('.next-button').on('click', function() {
      if (currentStep < 5) {
        currentStep++;
        showStep(currentStep);
      }
    });

    // Event handler for "Previous" button
    $('.prev-button').on('click', function() {
      if (currentStep > 1) {
        currentStep--;
        showStep(currentStep);
      }

      $('#multistep-form .step-position').addClass('active');
    });

    $('#multistep-form .step-3 .next-button').on('click', function(){
      $('#multistep-form .step-position').removeClass('active');
    });

    $('#multistep-form .step-4 .calculate-button').on('click', function(){
      // Input Values
      var employeerCount = $('#step-1-number').val();
      var industryType = $('#step-2-select').val();
      var sickType = $('#step-3-select').val();

      // Iterate through each .outcome-calc element
      var dataArray = [];

      $('.outcome-calc').each(function() {
        var staffMin = parseInt($(this).data('min-staff'));
        var staffMax = parseInt($(this).data('max-staff'));
        var dataType = $(this).data('type');
        var dataAmount;

        if (!isNaN(staffMin) && !isNaN(staffMax)) {
          if (employeerCount >= staffMin && employeerCount <= staffMax) {
            dataAmount = parseFloat($(this).data('amount'));
          }
        } else if (!isNaN(staffMax)) {
          if (employeerCount <= staffMax) {
            dataAmount = parseFloat($(this).data('amount'));
          }
        } else if (!isNaN(staffMin)) {
          if (employeerCount >= staffMin) {
            dataAmount = parseFloat($(this).data('amount'));
          }
        } else {
          console.log('Error!');
        }

        if (typeof dataAmount !== 'undefined') {
          var dataObject = { amount: dataAmount, type: dataType, sickType: sickType, numberEmployees: employeerCount };
          dataArray.push(dataObject);
        }
      });
           
      // Calculator Values
      var averageSickness = $('#average-sickness').text();
      var assumedStatutory = $('#assumed-statutory').text();
      var assumedEnhanced = $('#assumed-enhanced').text();
      var fullDay = $('#full-day').text();
      var halfDay = $('#half-day').text();
      let sickVal = false;
      let estimatedMsk = false;
      var fullDaysValue = false;
      var halfDaysValue = false;
      var numberEmployees = false;
      
      // Using $.each() function
      $.each(dataArray, function(index, obj) {
        // Number of employees
        numberEmployees = obj.numberEmployees;
        
        // Sick leave type
        sickVal = obj.sickType;

        // Type of sick full or half day
        let type = obj.type;
        if (type == 'full-days') {
          fullDaysValue = obj.amount;
        }

        if (type == 'half-days') {
          halfDaysValue = obj.amount;
        }
      });

      // Cost estimates statutory
      if (sickVal == 'statutory') {
        estimatedMsk = numberEmployees * 0.0149 * assumedStatutory * averageSickness;
      }

      // Cost estimates statutory
      if (sickVal == 'enhanced') {
        estimatedMsk = numberEmployees * 0.0149 * assumedEnhanced * averageSickness;
      }

      let estimatedMskVal = Math.round(estimatedMsk);

      let estimatedPresenteeism = estimatedMsk * 2;
      let estimatedPresenteeismVal = Math.round(estimatedPresenteeism);
     
      let cumlativeMsk = estimatedMsk + estimatedPresenteeism;
      let cumlativeMskVal = Math.round(cumlativeMsk);

      let fullCosts = 0;
      let halfCosts = 0;

      if (fullDaysValue !== 0) {
        fullCosts = fullDaysValue * fullDay * 47;
      }

      if (halfDaysValue !== 0) {
        halfCosts = halfDaysValue * halfDay * 47;
      }
      
      let annualBiaCosts = fullCosts + halfCosts;  
      
      let annualBiaCostsVal = Math.round(annualBiaCosts);
      
      let assumedRoi = cumlativeMsk / annualBiaCosts;
      let assumedRoiVal = assumedRoi.toFixed(2);
      
      // Updates HTML values on button click
      $('.step-5 .estimated-msk span.figure').text(estimatedMskVal.toLocaleString());
      $('.step-5 .estimated-presenteeism span.figure').text(estimatedPresenteeismVal.toLocaleString());
      $('.step-5 .cumlative-msk span.figure').text(cumlativeMskVal.toLocaleString());
      $('.step-5 .annual-bia-costs span.figure').text(annualBiaCostsVal.toLocaleString());
      $('.step-5 .assumed-roi span.figure').text(assumedRoiVal);

      // Submit data into the ninja form for submission
      $('#results-form .estimated-msk').attr('value', estimatedMsk).trigger('change');
      $('#results-form .estimated-presenteeism').attr('value', estimatedPresenteeism).trigger('change');
      $('#results-form .cumlative-msk').attr('value', cumlativeMsk).trigger('change');
      $('#results-form .annual-bia-costs').attr('value', annualBiaCosts).trigger('change');
      $('#results-form .assumed-roi').attr('value', assumedRoiVal).trigger('change');
      $('#results-form .industry').attr('value', industryType).trigger('change');
    });

    // Ninja Forms Validation — enable the "Calculate Absence" button once a name and
    // a valid email are present.
    //
    // The old version bound an `input` handler directly onto the fields inside the
    // nfFormReady callback. That left the button stuck greyed-out whenever:
    //   - nfFormReady had already fired before this script ran (load-order race),
    //   - Ninja Forms re-rendered its fields after a validation error (handler lost),
    //   - the browser autofilled or restored values without firing `input`.
    // Any of these hit some users and not others, which is the reported symptom.
    //
    // Fix: a delegated handler on the static #results-form container (survives NF
    // re-renders and doesn't depend on nfFormReady timing), across the events that
    // value changes actually fire, plus an initial check and a WebKit-autofill hook
    // so the button enables the moment the fields are populated by any means.
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function refreshCalculateButton() {
      var nameValue = $('#results-form .your-name').val();
      var emailValue = $('#results-form .your-email').val();
      nameValue = nameValue ? nameValue.trim() : '';
      emailValue = emailValue ? emailValue.trim() : '';

      var valid = nameValue !== '' && emailRegex.test(emailValue);
      $('#multistep-form .calculate-button').prop('disabled', !valid);
    }

    // Detect Chrome/Safari autofill (which can populate fields without an input/change
    // event) via the :-webkit-autofill animation hook.
    if (!document.getElementById('calc-autofill-style')) {
      var afStyle = document.createElement('style');
      afStyle.id = 'calc-autofill-style';
      afStyle.textContent =
        '@keyframes calcAutofill{from{}to{}}' +
        '#results-form .your-name:-webkit-autofill,' +
        '#results-form .your-email:-webkit-autofill{animation-name:calcAutofill;}';
      document.head.appendChild(afStyle);
    }

    // Delegated to the static #results-form container so it keeps working after
    // Ninja Forms re-renders the inputs; namespaced + off() first to avoid stacking
    // duplicate handlers if nfFormReady fires more than once.
    $('#results-form')
      .off('input.calc change.calc blur.calc keyup.calc animationstart.calc', '.your-name, .your-email')
      .on('input.calc change.calc blur.calc keyup.calc', '.your-name, .your-email', refreshCalculateButton)
      .on('animationstart.calc', '.your-name, .your-email', function(e) {
        var anim = e.originalEvent && e.originalEvent.animationName;
        if (anim === 'calcAutofill') refreshCalculateButton();
      });

    // Cover values already present (prefill / bfcache restore) whether or not
    // nfFormReady has already fired.
    refreshCalculateButton();
    $(document).on('nfFormReady', function(e, layoutView) {
      refreshCalculateButton();
    });

    // Handle click event on external button
    $('.calculate-button').on('click', function(e) {
      e.preventDefault();

      // Change the text on the button when clicked
      $(this).text("Calculating Absence...");

      // Trigger form submission by simulating click on the submit button after a short delay
      setTimeout(function() {
        $('#results-form .submit-button').click();
      }, 10);

      // Move to the results of the calculation
      setTimeout(function(){
        $('.form-step:not(.step-5)').removeClass('active');
        $('.form-step:not(.step-5)').addClass('d-none');
        $(this).addClass('d-none');
        $('.step-5').addClass('active');
      }, 1000);
    });

    $('.step-5 .prev-button').on('click', function(e) {
      e.preventDefault();

      // Remove d-none class
      $('.form-step:not(.step-5)').removeClass('d-none');

      // Remove values from visiblity
      $('.step-5').removeClass('active');

      // Remove calss on calculate BTN && Change the text on the button
      $('.step-4 .calculate-button').removeClass('d-none');
      $('.step-4 .calculate-button').text("Calculate Absence");

      // Reset Ninja Forms fields
      $('#results-form .your-name').val('').trigger('change');
      $('#results-form .your-email').val('').trigger('change');
      $('#results-form .your-name').text('').trigger('change');
      $('#results-form .your-email').text('').trigger('change');
    });

  $.fn.isScrolledIntoView = function () {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(this).offset().top;
    return elemTop <= docViewBottom && elemTop >= docViewTop;
  };
});

/**
 * @description loads the AOS library after a set timeout
 */
let loadAOS = () => {
  setTimeout(() => {
    $("body").addClass("loaded");
    setTimeout(() => {
      AOS.init();
    }, 500);
  }, 1000);
};

/**
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
 */
 let checkWindowScroll = () => {
  let scroll = $(window).scrollTop();
  let noHero = false;

  if ($('#hero').length === 0 && $('#ctaHero').length === 0) {
    noHero = true;
  }

  if (noHero == true || scroll > 0) {
    $("header").addClass("scroll");
  } else {
    $('header').removeClass('scroll');
  }
};

let hoverLinks = () => {
  // Add hover event handler to add the 'hover' class when hovering over the menu
  $("#navigation > ul > li.nav-item").hover(
    function() {
      $(this).addClass("hover-active");
      $("header").addClass("scroll-link");
    },
    function() {
      $(this).removeClass("hover-active");
      $("header").removeClass("scroll-link");
    }
  );
};

/**
 * @description function for fixing floating elements or page width elements with content to the conventional bootstrap container sizes
 */

let containerFix = () => {
  if ($('.container-fix').length) {
    let containerWidths = {
      576: 540,
      768: 720,
      992: 960,
      1200: 1140,
      1440: 1440,
    };
    let windowWidth = $(window).width();
    let containerWidth = 0;
    for (const [key, value] of Object.entries(containerWidths)) {
      if (windowWidth >= key) {
        containerWidth = value;
      }
    }

    var padding = ((windowWidth - containerWidth) / 2) + 32;
    if (windowWidth >= 992) {
      $('.container-fix').each(function () {
        if ($(this).hasClass('odd')) {
          $(this).css('padding-left', '0px');
          $(this).css('padding-right', padding + 'px');
        } else if ($(this).hasClass('even')) {
          $(this).css('padding-left', padding + 'px');
          $(this).css('padding-right', '0px');
        }
      });
    } else if (windowWidth >= 576 && windowWidth <= 991) {
      $('.container-fix').each(function () {
        $(this).css('padding-left', padding + 'px');
        $(this).css('padding-right', padding + 'px');
      });
    } else {
      $('.container-fix').each(function () {
        $(this).css('padding-left', '32px');
        $(this).css('padding-right', '32px');
      });
    }
  }
};

/**
 *  @description affix appropriately css positioned elements (ie position = fixed || absolute) below the header banner
 */
let submenuOffset = () => {
  let headerHeight = $("#header").outerHeight();
  let dropdown = $(".submenu");
  let megamenu = $(".submenu.megamenu");
  let scroll = $(document).scrollTop();
  let topstripHeight = 0;
  let simpleMenu = headerHeight - 77;

  if ($('body').hasClass('logged-in') && $('body').hasClass('admin-bar')) {
    headerHeight = headerHeight + 32;
  } else {
    headerHeight = headerHeight;
  }

  if (scroll == 0) {
    dropdown.css("top", simpleMenu + "px");
    megamenu.css("top", headerHeight + "px");
  } else if (scroll < topstripHeight) {
    dropdown.css("top", scroll + simpleMenu + "px");
    megamenu.css("top", scroll + headerHeight + "px");
  } else {
    dropdown.css("top", simpleMenu + "px");
    megamenu.css("top", headerHeight + "px");
  }
};

/**
 * @description offset elements labeled with the offset hero class by the height of the header
 */
let heroOffset = () => {
  let hero = $(".offset-hero");
  let header = $("header");

  if (hero.length && header.length) {
    let height = $(header).outerHeight();
    $(hero).css("margin-top", `${height}px`);
  }
};

/**
 * @description reveals hidden page elements
 */
let uncoverElements = () => {
  $(".uncover").each(function () {
    if ($(this).isScrolledIntoView() === true) {
      $(this).addClass("show");
    }
  });
};

/**
 * @description initialise the slick sliders for the page
 */
let initSliders = () => {
  // generic slider example
  // go to - https://kenwheeler.github.io/slick/ - for documentation
  $(".timeline-slider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    vertical: true,
    verticalSwiping: true,
    asNavFor: '.timeline-nav',
    infinite: false,
  });
  
  $(".case-study-slider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    asNavFor: '.case-study-nav',
    infinite: true,
  });
  
  $(".case-study-img-slider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    asNavFor: '.case-study-nav',
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1439,
        settings: {
          slidesToShow: 3,
          vertical: true,
          verticalSwiping: true,
          centerMode: true,
          focusOnSelect: true,
        }
      },
    ],
  });
  
  $(".case-study-nav-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    asNavFor: '.case-study-nav',
    infinite: true,
  });

  $(".icon-statement-slider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    asNavFor: '.icon-statement-nav',
    infinite: true,
    mobileFirst: true,
    speed: 350,
    fade: true,
    cssEase: 'linear',
  });

  setTimeout(function() {
    $(".icon-statement-img-slider").slick({
      dots: false,
      arrows: true,
      nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
      prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
      slidesToScroll: 1,
      slidesToShow: 1,
      asNavFor: '.icon-statement-nav',
      infinite: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            vertical: true,
            verticalSwiping: true,
            centerMode: true,
          }
        },
      ],
    });
  }, 2000);

  $(".icon-statement-nav-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    vertical: true,
    verticalSwiping: true,
    asNavFor: '.icon-statement-nav',
    infinite: true,
  });
  
  $(".timeline-slider-v2").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 2,
    vertical: true,
    verticalSwiping: true,
    asNavFor: '.timeline-nav',
    infinite: true,
  });

  $(".timeline-img-slider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    vertical: true,
    verticalSwiping: true,
    asNavFor: '.timeline-nav',
    infinite: false,
  });

  $(".timeline-nav-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    vertical: true,
    verticalSwiping: true,
    asNavFor: '.timeline-nav',
    infinite: false,
  });

  $(".review-slider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    asNavFor: '.review-nav',
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
        }
      },
    ],
  });

  $(".review-nav-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    asNavFor: '.review-nav',
    infinite: true,
  });

  $(".accreditation-slider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 2,
        },
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
        },
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        }
      },
    ],
  });

  $(".accreditation-short-slider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 2,
        },
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
        }
      },
    ],
  });

  $(".stat-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 2,
    slidesToShow: 2,
    centerMode: true,
    infinite: true,
    centerPadding: 0,
  });

  $(".stat-mobile-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    centerMode: true,
    infinite: true,
    centerPadding: 0,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
    ],
  });

  $(".team-slider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    asNavFor: '.team-nav',
    infinite: true,
  });

  $(".team-nav-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    asNavFor: '.team-nav',
    infinite: true,
  });
};

/**
 * @description handles opening and closing of the mobile menu on the site
 *
 * @param {*} open flag indicating whether or not the menu is in an open state
 */
var open = false;
let toggleMenu = (open) => {
  $("#burger").toggleClass("open", open);
  $("#navigation-mobile > ul").toggleClass("open", open);
};

/**
 * @description centers the map on the current marker or in the center of all markers present
 *
 * @param {*} map the JSON map object being worked on
 */
let centerMap = (map) => {
  let bounds = new google.maps.LatLngBounds();
  $.each(map.markers, function (i, marker) {
    let latlng = new google.maps.LatLng(
      marker.position.lat(),
      marker.position.lng()
    );
    bounds.extend(latlng);
  });
  if (map.markers.length == 1) {
    map.setCenter(bounds.getCenter());
    map.setZoom(map.zoom);
  } else {
    map.fitBounds(bounds);
  }
};

/**
 * @description adds a new marker to the map being created
 *
 * @param {*} $marker the jQuery HTML marker to be added
 * @param {*} map the JSON map object to be operated on
 */
 let addMarker = ($marker, map) => {
  let latlng = new google.maps.LatLng(
    parseFloat($marker.attr("data-lat")),
    parseFloat($marker.attr("data-lng"))
  );
  
  let iconUrl = $marker.attr("data-icon") || '/wp-content/themes/frogspark/img/pin.svg'; // Default value if data-icon attribute is missing
  
  // Define icon object with default scaledSize
  let icon = {
    url: iconUrl,
    scaledSize: new google.maps.Size(48, 48) // Default size
  };
  
  // Check if $marker has class 'large-marker' to adjust scaledSize
  if ($marker.hasClass('large-marker')) {
    icon.scaledSize = new google.maps.Size(68, 68);
  }
  
  let marker = new google.maps.Marker({
    icon: icon,
    map: map,
    position: latlng,
  });
  
  map.markers.push(marker);
  
  if ($marker.html()) {
    let infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
    });
    google.maps.event.addListener(marker, "click", function () {
      infowindow.open(map, marker);
    });
  }
};

/**
 * @description creates a new map at the location of the jQuery element passed in
 *
 * @param {*} $el the jQuery element to create a map aroudn
 */
let newMap = ($el) => {
  let $markers = $el.find(".marker");
  let args = {
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: [
      {
        "featureType": "all",
        "elementType": "all",
        "stylers": [
          {
            "saturation": "39"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
          {
            "hue": "#0083ff"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
          {
            "hue": "#0083ff"
          }
        ]
      },
      {
        "featureType": "landscape.natural.landcover",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "saturation": "0"
          }
        ]
      },
      {
        "featureType": "poi.attraction",
        "elementType": "all",
        "stylers": [
          {
            "hue": "#0083ff"
          }
        ]
      },
      {
        "featureType": "poi.business",
        "elementType": "all",
        "stylers": [
          {
            "hue": "#0083ff"
          }
        ]
      },
      {
        "featureType": "poi.government",
        "elementType": "all",
        "stylers": [
          {
            "hue": "#0083ff"
          }
        ]
      },
      {
        "featureType": "poi.medical",
        "elementType": "all",
        "stylers": [
          {
            "hue": "#0083ff"
          }
        ]
      },
      {
        "featureType": "poi.place_of_worship",
        "elementType": "all",
        "stylers": [
          {
            "hue": "#0083ff"
          }
        ]
      },
      {
        "featureType": "poi.school",
        "elementType": "all",
        "stylers": [
          {
            "hue": "#0083ff"
          }
        ]
      },
      {
        "featureType": "poi.sports_complex",
        "elementType": "all",
        "stylers": [
          {
            "hue": "#0083ff"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
          {
            "hue": "#0083ff"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
          {
            "hue": "#0083ff"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
          {
            "hue": "#0083ff"
          }
        ]
      }
    ],
    zoom: 12,
  };
  let map = new google.maps.Map($el[0], args);
  map.markers = [];
  $markers.each(function () {
    addMarker($(this), map);
  });
  centerMap(map);
  return map;
};

/**
 * @description convenience function for running all code required to generate a single (or multiple) maps on a page
 */
let initGoogleMapping = () => {
  $(".map").each(function () {
    newMap($(this));
  });
};

/**
 * @description loads timages via the server over local files
 */
let imageReplace = () => {  
  var host = window.location.hostname;

  // Check if the current host matches the expected host
  if (host === 'sano-physiotherapy.test' || host === 'localhost:3000' || host === 'localhost') {
    host = 'www.sanophysiotherapy.com';
  }

  // Replace domain in <img> src attributes
  $('img').each(function () {
    const currentSrc = $(this).attr('src');

    // Update test domain
    if (currentSrc && currentSrc.includes('sano-physiotherapy.test')) {
      $(this).attr('src', currentSrc.replace('sano-physiotherapy.test', host));
    }

    // Update local domain
    if (currentSrc && currentSrc.includes('localhost:3000')) {
      $(this).attr('src', currentSrc.replace('localhost:3000', host));
    }
  });

  // Replace domain in <video> src attributes
  $('video').each(function () {
    const currentSrc = $(this).attr('src');
    const currentPoster = $(this).attr('poster');

    // Update test domain
    if (currentSrc && currentSrc.includes('sano-physiotherapy.test')) {
      $(this).attr('src', currentSrc.replace('sano-physiotherapy.test', host));
    }

    if (currentPoster && currentPoster.includes('sano-physiotherapy.test')) {
      $(this).attr('poster', currentPoster.replace('sano-physiotherapy.test', host));
    }

    // Update local domain
    if (currentSrc && currentSrc.includes('localhost:3000')) {
      $(this).attr('src', currentSrc.replace('localhost:3000', host));
    }

    if (currentPoster && currentPoster.includes('localhost:3000')) {
      $(this).attr('poster', currentPoster.replace('localhost:3000', host));
    }
  });

  // Replace domain in <div> background-image style attributes
  $('div').each(function () {
    const currentBg = $(this).css('background-image');

    // Update test domain
    if (currentBg && currentBg.includes('sano-physiotherapy.test')) {
      const updatedBg = currentBg.replace('sano-physiotherapy.test', host);
      $(this).css('background-image', updatedBg);
    }

    // Update local domain
    if (currentBg && currentBg.includes('localhost:3000')) {
      const updatedBg = currentBg.replace('localhost:3000', host);
      $(this).css('background-image', updatedBg);
    }
  });
};